import React from 'react';
import DatePicker from 'react-datepicker';
import '../component/css/customDatePicker.css';

function CustomDatePicker({
  value = '',
  onChange = () => {},
  onTypeChange = () => {},
  size = '',
  placeholder = '',
  isClearable=false
}) {
  return (
    <div className='customDatePickerWidth'>
      <DatePicker
        dateFormat='dd-MM-yyyy'
        selected={ value }
        onChange={ onChange }
        onChangeRaw={ e => e }
        className={ `form-control form-control-${ size }` }
        isClearable={ isClearable }
        showMonthDropdown
        showYearDropdown
        dropdownMode='select'
        placeholderText={ placeholder }
      />
    </div>
  );
}

export default CustomDatePicker;
